import { render, h } from 'preact';

import EmbedApp from '../EmbedApp';
import parseQueryString from '../utils/parse-query-string';

const { contest } = parseQueryString(location.search);

let selectedContests;

if (Array.isArray(contest)) {
  selectedContests = contest;
} else {
  if (contest != null) {
    selectedContests = [contest];
  } else {
    selectedContests = [];
  }
}

render(
  <EmbedApp selectedContests={selectedContests} />,
  document.getElementById('app')
);
